// TODO as apis reais devem ser implementadas e tratadas na CB-269

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { endpoints } from '../../../environments/environment';
import { RegisteredDeviceSituationEnum, RegisteredDeviceType } from './models/registered-device';

@Injectable()
export class DeviceManagementService {
	private readonly url = endpoints.deviceManagement;

	constructor(private readonly http: HttpClient) { }

	getRegisteredDevice(): Observable<RegisteredDeviceType> {
		return new Observable<RegisteredDeviceType>(observer => {
			observer.next({
				IdentDispositivo: 'FCDBD8EF-62FC-4ECB-B2F5-92C9E79AC7F9',
				Data: '2024-10-16',
				Modelo: 'iPhone 15',
				Situacao: RegisteredDeviceSituationEnum.ACTIVE,
			});
			observer.complete();
		});
	}

}



// WEBPACK FOOTER //
// /home/ubuntu/workdir/workspace/Front End Angular (NGINX)/omni-internetbanking/dev-omni-internetbanking-deploy/src/app/master/device-management/device-management.service.ts